import { api } from '@/lib/api/client'
import type {
  LegalDocumentAdminItem,
  LegalDocumentType,
  LegalDocumentsAdminListResponse,
} from '@/types/legal-documents'

export async function fetchLegalDocumentsAdmin(
  documentType: LegalDocumentType
): Promise<LegalDocumentsAdminListResponse> {
  const params = new URLSearchParams({ document_type: documentType })
  return api.get<LegalDocumentsAdminListResponse>(
    `/api/admin/legal-documents?${params.toString()}`,
    { requireAuth: true }
  )
}

export async function publishLegalDocument(input: {
  document_type: LegalDocumentType
  version: string
  content: string
}): Promise<LegalDocumentAdminItem> {
  const response = await api.post<{ document: LegalDocumentAdminItem }>(
    '/api/admin/legal-documents',
    input,
    { requireAuth: true }
  )
  return response.document
}
